"use strict";
var client_1 = require("./client");
exports.Client = client_1.default;
var server_1 = require("./server");
exports.SubscriptionServer = server_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/subscriptions-transport-ws/dist/index.js
// module id = 791
// module chunks = 0